// globals: jQuery

/**
 * Payment Controller
 */
var PaymentController = (function($) {
    return {

        /**
         * Init
         */
        init: function(params) {
            var self = this;
            if (params['shoppingCartItemExists']) {
                $('.js-take-payment-btn').show();
                $('.js-take-payment-btn-disabled').hide();
            } else {
                $('.js-take-payment-btn-disabled').show();
                $('.js-take-payment-btn').hide();
            }
            self.initEvents();
            this.isInitialized = true;
        },
        initEvents: function () {
            $('body').on('click', '.pickupRadio', function () {
                var $deliverLocation = $('#deliverLocation');
                var $checked        = $('.pickupRadio:checked');

                $('[data-name=deliverLocation]').remove();
                $deliverLocation.css({
                  borderWidth: 0,
                  borderStyle: 'none'
                });

                if ($checked.val() == 0) {
                    $deliverLocation.prop({readonly: false, required: true});
                } else {
                    $deliverLocation.prop({readonly: true, required: false});
                }
            });
        },
        validateOnSubmit: function(buttonId, formId) {
          $('#' + buttonId).on('click', function(event) {
            event.preventDefault();
            var $form               = $('#' + formId),
                $submitContainer    = $form.find('.submit-buttons'),
                $required           = $form.find('input:required'),
                $err                = $('<div class="error validation-error"></div>'),
                message             = 'Please enter a ',
                errorCount          = 0,
                $this, $newErr;

            $required.each( function() {
              $this = $(this);
              if (!$this.val().length) {
                errorCount++;
                $newErr = $err.clone().text(message + $this.attr('title'));
                $newErr.attr('data-name', $this.attr('name'));

                $this.css({
                  borderColor: 'red',
                  borderWidth: 1,
                  borderStyle: 'solid'
                });
                if ($submitContainer.find('[data-name=' + $this.attr('name')+']').length) {
                  return false;
                }
                $submitContainer.append($newErr);
              }
            });

            if (errorCount) {
              return false;
            }

            if ($form.find('[name=payment_type]').val()) {
              event.target.disabled='disabled';
              $form.get(0).onsubmit();
            } else {
              jQuery.caAlert('Please select payment type first.');
            }
          });
        }
    }
})(jQuery);

window.PaymentController = PaymentController;
